import { Link } from '../router';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className={`brand ${compact ? 'brand-compact' : ''}`} to="/" aria-label="Messavo home">
      <span className="brand-mark" aria-hidden="true"><i /><i /></span>
      {!compact && <span>Messavo</span>}
    </Link>
  );
}
